import { jsx, jsxs } from "@ecopages/jsx/jsx-runtime";
import { createNumericRange } from "../shared/numeric-range";
import { createKnobRing } from "./knob-geometry";
import "./knob.script";
export function RuiKnob({
  value = 50,
  min = 0,
  max = 100,
  step = 1,
  disabled = false,
  readOnly = false,
  label,
  name,
  size,
  strokeWidth = 14,
  showValue = true,
  valuePosition = "center",
  valueTemplate = "{value}",
  ...props
}) {
  const range = createNumericRange(min, max, step);
  const resolvedValue = range.clamp(value);
  const ring = createKnobRing(resolvedValue, min, max, step, strokeWidth, valueTemplate);
  const valueBelow = valuePosition === "below";
  const sizeStyle = size ? {
    "--rui-knob-size": `${size}px`
  } : void 0;
  return /* @__PURE__ */jsx("rui-knob", {
    ...props,
    value: resolvedValue,
    min,
    max,
    step,
    disabled,
    "prop:readOnly": readOnly,
    label,
    name,
    size,
    strokeWidth,
    showValue,
    valuePosition,
    valueTemplate,
    style: sizeStyle,
    children: /* @__PURE__ */jsxs("div", {
      class: valueBelow ? "rui-knob rui-knob--value-below" : "rui-knob",
      "data-ref": "root",
      children: [/* @__PURE__ */jsx("span", {
        class: "rui-knob__label",
        "data-ref": "label",
        hidden: !label,
        children: label
      }), /* @__PURE__ */jsxs("button", {
        type: "button",
        class: "rui-knob__control",
        "data-ref": "control",
        "data-knob-control": true,
        role: "slider",
        "aria-label": label || void 0,
        "aria-valuemin": range.lowerBound,
        "aria-valuemax": range.upperBound,
        "aria-valuenow": resolvedValue,
        "aria-valuetext": ring.valueText,
        "aria-readonly": readOnly,
        disabled,
        children: [/* @__PURE__ */jsxs("svg", {
          class: "rui-knob__svg",
          viewBox: "0 0 100 100",
          "aria-hidden": "true",
          children: [/* @__PURE__ */jsx("circle", {
            class: "rui-knob__track",
            "data-ref": "track",
            cx: "50",
            cy: "50",
            r: ring.radius,
            fill: "none",
            "stroke-width": ring.strokeWidth,
            "stroke-dasharray": `${ring.arcLength} ${ring.circumference}`,
            transform: `rotate(${ring.startAngle} 50 50)`
          }), /* @__PURE__ */jsx("circle", {
            class: "rui-knob__progress",
            "data-ref": "progress",
            cx: "50",
            cy: "50",
            r: ring.radius,
            fill: "none",
            "stroke-width": ring.strokeWidth,
            "stroke-dasharray": `${ring.progressLength} ${ring.circumference}`,
            transform: `rotate(${ring.startAngle} 50 50)`
          })]
        }), /* @__PURE__ */jsx("span", {
          class: "rui-knob__value",
          "data-ref": "centerValue",
          "aria-hidden": "true",
          hidden: !showValue || valueBelow,
          children: ring.valueText
        })]
      }), /* @__PURE__ */jsx("span", {
        class: "rui-knob__value rui-knob__value--below",
        "data-ref": "belowValue",
        "aria-hidden": "true",
        hidden: !showValue || !valueBelow,
        children: ring.valueText
      }), /* @__PURE__ */jsx("input", {
        "data-ref": "input",
        type: "hidden",
        name: name || void 0,
        value: resolvedValue
      })]
    })
  });
}